import script from "./base-form-errors.vue?vue&type=script&setup=true&lang=js"
export * from "./base-form-errors.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__